import {
  Breadcrumbs,
  Button,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import Structure from '../Structure';
import { Link, useParams } from 'react-router-dom';
import { Link as Enlace } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import data from '../../lib/backend/data';
import toast from 'react-hot-toast';
import { cerrarSesion } from '../../redux/actions/session';

const SoporteCreate = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [soporte, setSoporte] = useState({});
  const sesion = useSelector((state) => state.miusuario);

  const handleChange = (e) => {
    const { name, value } = e.target;
    soporte[name] = value;
    return setSoporte({ ...{}, ...soporte });
  };

  const crearSoporte = async () => {
    const requeridos = [
      { value: 'titulo', label: 'Titulo' },
      { value: 'tipo', label: 'Tipo' },
    ];
    let faltantes = [];
    requeridos.map((campo) => {
      if (!soporte[campo.value]) faltantes.push(campo.label);
      return true;
    });
    if (faltantes.length > 0)
      return toast.error(`Faltan campos: ${faltantes.join(', ')}`);

    setLoading(true);
    return fetch(`${data.urlapi}/soporte`, {
      method: 'POST',
      body: JSON.stringify(soporte),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer: ${sesion.tokenSession}`,
      },
    })
      .then((res) => {
        if (res.status === 401) return dispatch(cerrarSesion());
        return res.json();
      })
      .then((res) => {
        if (!res) {
          toast.error('Sin datos');
          return setLoading(false);
        } else if (res.errorMessage) {
          toast.error(res.errorMessage);
          return setLoading(false);
        } else if (res._id) {
          toast.success('Creado exitosamente');
          setTimeout(() => {
            return (window.location = '/soporte');
          }, 500);
        }
        return setLoading(false);
      })
      .catch((error) => {
        toast.error('Error al consultar la información, intente nuevamente');
        return setLoading(false);
      });
  };

  const render = () => {
    return (
      <div>
        <Breadcrumbs aria-label='breadcrumb'>
          <Link to='/soporte'>Categoria-Soporte</Link>
          <Enlace underline='hover' color='text.primary'>
            Crear Categoria-Soporte
          </Enlace>
        </Breadcrumbs>
        <h1 style={{ margin: 0 }}>Crear Categoria-Soporte</h1>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item md={12} xs={12}>
            <Typography variant='h6'>Datos</Typography>
          </Grid>
          <Grid item md={3} xs={12}>
            <TextField
              label='Titulo'
              variant='filled'
              name='titulo'
              fullWidth
              onChange={handleChange}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <FormControl fullWidth className='mb-3'>
              <InputLabel id='demo-simple-select-label'>Tipo</InputLabel>
              <Select
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                label='Tipo'
                name='tipo'
                onChange={handleChange}
                defaultValue={soporte.tipo}
              >
                <MenuItem value='conductor'>Conductor</MenuItem>
                <MenuItem value='cliente'>Cliente</MenuItem>
                <MenuItem value='empresa'>Empresa</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item md={12} xs={12}>
            {loading === true ? (
              <CircularProgress />
            ) : (
              <Button
                variant='contained'
                xs={{ m: 0 }}
                onClick={() => crearSoporte()}
              >
                CREAR
              </Button>
            )}
          </Grid>
        </Grid>
      </div>
    );
  };

  return <Structure component={render()} />;
};

export default SoporteCreate;
